import React from 'react';

import classnames from 'classnames';
import style from './index.scss';
import Tree from 'react-d3-tree';
import Table from '../../dashboard/TookiTakiTable/Table';
import {
  FeatureDataModelWithDownload,
  SingleTD
} from '../../../../components/HoverableTD';
import NoDataToDisplay from '../../../../components/NoDataToDisplay';
import * as PropTypes from 'prop-types';
import {
  getDecimalInPercentage,
  getInDecimal,
  putHyphenIfEmpty
} from '../../../../services/util';
import {
  EXCLUDED_RED_FLAGS,
  FEATURE_VIEW_MAP,
  getNTopOrderedFeatures,
  MAX_NUM_FEATURES
} from './explanabilityConstants';
import Wait4Me from '../../../../components/Wait4Me';
import {
  FORMAT_TYPE_DOUBLE,
  FORMAT_TYPE_INT,
  FORMAT_TYPE_MONEY,
  FORMAT_TYPE_RATIO,
  FORMAT_TYPE_STRING,
  formatterUtil
} from '../../../../services/formattterUtil';
import { normalizeAlertScore } from '../../../../util/normalization';

import { capitalize, find } from '../../../../util/lodashlike';
/**
 * This is Feature Value Returner Function which checks for certains hints
 * of feature Name and decides what type of value to be returned
 * @param featureValue
 * @param featureType
 * @param defaultReturnValue
 * @returns {string|*}
 */
export const getMatchedFeatureValue = (
  featureValue,
  featureType,
  defaultReturnValue = '-'
) => {
  if (featureValue === '-') {
    return '-';
  }
  switch (featureType) {
    case 'AMOUNT':
      return formatterUtil(featureValue, FORMAT_TYPE_MONEY, defaultReturnValue);
    case 'RATIO':
      return formatterUtil(featureValue, FORMAT_TYPE_RATIO, defaultReturnValue);
    case 'INTEGER':
      return formatterUtil(featureValue, FORMAT_TYPE_INT, defaultReturnValue);
    case 'STRING':
      return formatterUtil(
        featureValue,
        FORMAT_TYPE_STRING,
        defaultReturnValue
      );
    case 'DOUBLE':
    default:
      return formatterUtil(
        featureValue,
        FORMAT_TYPE_DOUBLE,
        defaultReturnValue
      );
  }
};

/**
 * getFeatureDescription
 * @param featureCodes
 * @param featureTypes
 * @param dataPoint
 * @returns {{featureCode: string, qualifiedName: string}}
 */

const getFeatureDescription = (featureCodes, featureTypes, dataPoint) => {
  let featureDesc = putHyphenIfEmpty(dataPoint);
  let fullDesc = '';
  let featureType = '';

  if (featureDesc === '-') {
    fullDesc = featureDesc;
  } else {
    fullDesc = find(featureCodes, { code: featureDesc });
    featureType = find(featureTypes, { code: featureDesc });
  }

  const { description = '-' } = fullDesc || {};
  const { description: featureTypeDesc = '-' } = featureType || {};

  return {
    qualifiedName: capitalize(putHyphenIfEmpty(description)),
    featureCode: featureDesc,
    featureType: featureTypeDesc
  };
};

/**
 * InnerRow component for Explanability
 */
class RedFlagFeatureTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false
    };
  }

  /**
   * setExpanded func
   */
  setExpanded = () => {
    const { isDisabled } = this.props;
    if (!isDisabled) {
      this.setState({ isExpanded: !this.state.isExpanded });
    }
  };

  /**
   * render
   * @returns {tr}
   */
  render() {
    let {
      redFlagFeature,
      alertDetail,
      isDisabled,
      transactionTypeFilterData,
      redFlagObject,
      featureCodes,
      featureTypeIdentifiers
    } = this.props;
    const { isExpanded } = this.state;
    const {
      name: redFlagFeatureDescription,
      featureValue: redFlagFeatureValue,
      contribution: redFlagFeatureContribution,
      featureComponents: redFlagFeatureComponents = []
    } = redFlagFeature || {};

    const {
      qualifiedName: description,
      featureCode,
      featureType
    } = getFeatureDescription(
      featureCodes,
      featureTypeIdentifiers,
      redFlagFeatureDescription
    );

    const {
      value: featureValue,
      type,
      maxValue = ''
    } = getMatchedFeatureValue(redFlagFeatureValue, featureType, '-');

    let innerValueTitle = 'Amount (SGD)';
    if (featureCode.indexOf('_VOL_') !== -1) {
      innerValueTitle = 'Volume';
    }
    if (featureCode.indexOf('_SD_') !== -1) {
      innerValueTitle = 'Standard Deviation';
    }

    return (
      <tr>
        <tr
          className={classnames(isExpanded ? style.disabled : style.enabled)}
          onClick={() => this.setExpanded(!isExpanded)}>
          <SingleTD
            dataPoint={description}
            fullDataPoint={description}
            innerRowStyle={style.innerRowStyle}
          />
          <td
            style={{
              fontSize: 11,
              fontWeight: 500,
              color: '#0c8ed7'
            }}
            className={style.innerRowStyle}>
            {getDecimalInPercentage(redFlagFeatureContribution)}
          </td>
          <td className={style.innerRowStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div title={type === FORMAT_TYPE_MONEY ? maxValue : featureValue}>
                {featureValue}
              </div>
              {!isDisabled && (
                <div>
                  <i
                    className={classnames(
                      'icon14',
                      isExpanded
                        ? 'icon14_icon_arrow_up'
                        : 'icon14_icon_arrow_down',
                      'ml-auto'
                    )}
                  />
                </div>
              )}
            </div>
          </td>
        </tr>
        {isExpanded && (
          <tr>
            <td className={classnames(style.innerRowStyle, style.bg)}>
              <strong>Component name</strong>
            </td>
            <td className={classnames(style.innerRowStyle, style.bg)}>
              <strong>Transaction type</strong>
            </td>
            <td className={classnames(style.innerRowStyle, style.bg)}>
              <strong>{innerValueTitle}</strong>
            </td>
          </tr>
        )}
        {isExpanded &&
          redFlagFeatureComponents.map((fc) => {
            return (
              <InnerInnerRow
                firstDP={getFeatureDescription(
                  featureCodes,
                  featureTypeIdentifiers,
                  fc.componentName
                )}
                secondDP={fc.value}
                transactionTypeFilterData={transactionTypeFilterData}
                alertDetail={alertDetail}
                thirdDP={fc.channelInfo}
                featureTypeIdentifiers={featureTypeIdentifiers}
                featureCodes={featureCodes}
              />
            );
          })}
      </tr>
    );
  }
}

/**
 * proptypes for component for Explanability
 * @type {{thirdDP: shim, alertDetail: shim, firstDP: shim, fourthDp: shim, secondDP: shim}}
 */
RedFlagFeatureTable.propTypes = {
  firstDP: PropTypes.any,
  secondDP: PropTypes.any,
  thirdDP: PropTypes.any,
  fourthDp: PropTypes.any,
  alertDetail: PropTypes.any
};
/**
 * InnerInnerRow for component for Explanability
 * @param firstDP
 * @param secondDP
 * @param thirdDP
 * @param alertDetail
 * @param transactionTypeFilterData
 * @param featureTypeIdentifiers
 * @returns {*}
 * @constructor
 */
const InnerInnerRow = ({
  firstDP,
  secondDP,
  thirdDP,
  alertDetail,
  transactionTypeFilterData,
  featureTypeIdentifiers
}) => {
  const { qualifiedName, featureCode, featureType } = firstDP || {};
  const {
    value: innerValue,
    type,
    maxValue = ''
  } = getMatchedFeatureValue(secondDP, featureType, '--');
  const noThirdDpContent = (
    <tr className={style.innerTRStyle}>
      <td className={style.enabled}>--</td>
      <td
        title={type === FORMAT_TYPE_MONEY ? maxValue : innerValue}
        className={style.enabled}>
        {innerValue}
      </td>
    </tr>
  );

  return (
    <tr className={classnames(style.trHeight)}>
      <SingleTD
        dataPoint={qualifiedName}
        fullDataPoint={qualifiedName}
        innerRowStyle={style.innerRowStyle}
      />
      <td colSpan="2" style={{ padding: 0 }}>
        {/* render dash for child features with not channel info */}
        {thirdDP.length === 0 ? noThirdDpContent : null}
        {thirdDP.map((channelInfo, index) => {
          const { channelType = 'NA', value = 'NA' } = channelInfo || {};
          const { qualifiedName: channelTypeDesc } = getFeatureDescription(
            transactionTypeFilterData,
            featureTypeIdentifiers,
            channelType
          );

          const {
            value: formattedFeatureValue,
            maxValue = '',
            type: fvType
          } = getMatchedFeatureValue(value, featureType, '--');
          return (
            <tr
              className={classnames(
                style.innerTRStyle,
                index % 2 === 0 ? style.lightBG : ''
              )}>
              <td className={style.enabled}>{channelTypeDesc}</td>
              <FeatureDataModelWithDownload
                associatedObject={{ ...alertDetail, channelInfo }}
                transactionName={qualifiedName}
                transactionCode={featureCode}
                maxValue={maxValue}
                featureType={fvType}
                firstDataPoint={formattedFeatureValue}
              />
            </tr>
          );
        })}
      </td>
    </tr>
  );
};

/**
 * ExpandableTable component for Explanability
 */
class ExpandableTable extends React.Component {
  constructor(props) {
    super(props);
    this.featureCodes = [];
    this.featureTypeIdentifiers = [];
    if (
      window.localStorage.getItem('featureCodes') &&
      this.featureCodes.length === 0
    ) {
      this.featureCodes = JSON.parse(
        window.localStorage.getItem('featureCodes')
      );
    }
    if (
      window.localStorage.getItem('featureTypeIdentifiers') &&
      this.featureTypeIdentifiers.length === 0
    ) {
      this.featureTypeIdentifiers = JSON.parse(
        window.localStorage.getItem('featureTypeIdentifiers')
      );
    }
  }

  render() {
    //GET ALL FEATURES CODES FROM LOCAL STORAGE IF POSSIBLE
    const { features, alertDetail, transactionTypeFilterData, redFlagObject } =
      this.props;
    const topNRedFlagFeatures = getNTopOrderedFeatures(
      features,
      MAX_NUM_FEATURES
    );

    return (
      <table className={style.expandableRowTable}>
        <tbody>
          {topNRedFlagFeatures.map((feature) => {
            let isDisabled = false;
            //IF A RED FLAG FEATURE HAS BREAKUP COMPONENTS
            //then show Chevron to expand else hide chevron and block expansion of row
            const { featureComponents: redFlagFeatureComponents = [] } =
              feature || {};
            const fcLength = redFlagFeatureComponents.length;
            if (fcLength === 0) {
              isDisabled = true;
            }

            if (EXCLUDED_RED_FLAGS.indexOf(feature.name) !== -1) {
              isDisabled = true;
            }

            return (
              <RedFlagFeatureTable
                transactionTypeFilterData={transactionTypeFilterData}
                isDisabled={isDisabled}
                redFlagObject={redFlagObject}
                featureCodes={this.featureCodes}
                featureTypeIdentifiers={this.featureTypeIdentifiers}
                redFlagFeature={feature}
                alertDetail={alertDetail}
              />
            );
          })}
        </tbody>
      </table>
    );
  }
}

const ExpandableRow = (props) => {
  const { featureData, alertDetail, transactionTypeFilterData } = props;
  const topNSortedRedFlags = getNTopOrderedFeatures(
    featureData,
    MAX_NUM_FEATURES
  );
  return (
    <tbody style={{ overflowY: 'scroll' }}>
      {topNSortedRedFlags.map((redFlag) => {
        return (
          <tr>
            {FEATURE_VIEW_MAP.map((fv) => {
              //RED FLAG CONTRIBUTING FEATURES
              if (fv.key === 'features') {
                const { features } = redFlag;
                return (
                  <td
                    style={{
                      lineHeight: 2,
                      padding: 0,
                      margin: 0
                    }}
                    colSpan="4">
                    <ExpandableTable
                      alertDetail={alertDetail}
                      redFlagObject={redFlag}
                      transactionTypeFilterData={transactionTypeFilterData}
                      features={features}
                    />
                  </td>
                );
              }
              //RED FLAG CONTRIBUTION
              if (fv.key === 'contribution') {
                return (
                  <td style={{ borderRight: '1px solid #d5dee7' }} key={fv.key}>
                    {getDecimalInPercentage(redFlag[fv.key])}
                  </td>
                );
              }
              return (
                <SingleTD
                  fullDataPoint={redFlag[fv.key]}
                  dataPoint={redFlag[fv.key]}
                  innerRowStyle={style.innerRowStyle}
                />
              );
            })}
          </tr>
        );
      })}
    </tbody>
  );
};

/**
 * treeContainerStyles component
 * @type {{backgroundColor: string, overflow: string, maxHeight: number, width: string, height: number}}
 */
const treeContainerStyles = {
  width: '100%',
  height: 400,
  backgroundColor: 'white',
  maxHeight: 400,
  overflow: 'scroll'
};
/**
 * AlertFeatureViewHeader
 * @returns {*}
 * @constructor
 */

const AlertFeatureViewHeader = () => {
  return (
    <thead className={style.stickyHeader}>
      <tr>
        <th colSpan="2">
          <strong>Red Flag</strong>
        </th>
        <th colSpan="3">
          <strong>Features</strong>
        </th>
      </tr>
      <tr>
        <th>Description</th>
        <th>Contribution</th>
        <th style={{ width: 350 }}>Description</th>
        <th style={{ width: 350 }}>Contribution</th>
        <th style={{ width: 350 }}>Value</th>
      </tr>
    </thead>
  );
};

/**
 * NodeLabel component
 */
class NodeLabel extends React.PureComponent {
  render() {
    const { className, nodeData, alertDetail } = this.props;
    if (alertDetail) {
      const score =
        alertDetail && alertDetail && alertDetail.score
          ? alertDetail.score
          : null;
      let level =
        alertDetail && alertDetail.alert_level ? alertDetail.alert_level : null;
      if (alertDetail.alert_type === 'ANOMALY') {
        level = 'L3';
      }
      let nodeValue = (
        <span>
          {nodeData.attributes?.['VALUE'] &&
            `Value: ${nodeData.attributes['VALUE']}`}
        </span>
      );
      let nodeScore = (
        <span>
          {nodeData.name &&
            nodeData.name === 'PREDICTION' &&
            score &&
            'Score: ' + getInDecimal(score)}
        </span>
      );
      let nodeName = (
        <span
          style={{
            wordWrap: 'break-word',
            width: '100px'
          }}>
          <b>{nodeData.name}</b>
        </span>
      );
      let redFlagContribution = null;

      const blueHighlightStyle = {
        background: '#0c8ed7',
        color: '#fff',
        padding: '3px',
        border: '1px solid #0c8ed7',
        borderRadius: '7px'
      };

      if (nodeData.attributes?.['RED_FLAG_CONTRIBUTION']) {
        redFlagContribution = (
          <span>
            Contribution:{' '}
            <b>
              {getDecimalInPercentage(
                nodeData.attributes['RED_FLAG_CONTRIBUTION']
              )}
            </b>
          </span>
        );
      }

      if (!nodeData._collapsed) {
        if (nodeData.name && nodeData.name === 'PREDICTION' && score) {
          nodeScore = (
            <span style={blueHighlightStyle}>
              {nodeData.name &&
                nodeData.name === 'PREDICTION' &&
                score &&
                'Score: ' + getInDecimal(score)}
            </span>
          );
        }

        if (nodeData?.name && nodeData.type === 'RED_FLAG') {
          nodeName = (
            <span
              style={{
                wordWrap: 'break-word',
                width: '100px',
                ...blueHighlightStyle
              }}>
              {nodeData.name}
            </span>
          );
        }
      }

      return (
        <div className={className}>
          {nodeName}
          {nodeData.name && nodeData.name === 'PREDICTION' && <br />}
          {nodeData.name && nodeData.name === 'PREDICTION' && <br />}
          <span>
            {nodeData.name &&
              nodeData.name === 'PREDICTION' &&
              level &&
              'Level: ' + level}
          </span>
          <br />
          <span
            style={
              nodeData.type === 'GROUP' && !nodeData._collapsed
                ? blueHighlightStyle
                : null
            }>
            {nodeData.attributes?.['CONTRIBUTION'] &&
              'Contribution: ' +
                getDecimalInPercentage(nodeData.attributes['CONTRIBUTION'])}
          </span>
          {redFlagContribution}
          <br />
          {nodeData.type === 'FEATURE' ? nodeValue : null}
          {nodeScore}
        </div>
      );
    }

    return null;
  }
}

/**
 * Explainability main component
 */
class Explainability extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  /**
   * constructor
   */
  constructor() {
    super();
    this.state = {
      currentTab: 0,
      tableWidth: '100%',
      prevLeft: -1,
      prevTop: -1,
      toLeft: 0,
      oneViewOffset: 138,
      translate: {}
    };
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.updateTableWidth();
    window.addEventListener('resize', this.updateTableWidth);

    if (this.treeContainer) {
      const dimensions = this.treeContainer.getBoundingClientRect();
      this.setState({
        ...this.state,
        dimensions,
        translate: {
          x: 100,
          y: dimensions.height / 2
        }
      });
    }
  }

  /**
   * componentWillUnmount
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateTableWidth);
  }

  /**
   * handleScroll
   * @param e
   */
  handleScroll = (e) => {
    const { prevTop } = this.state;
    if (prevTop === e.top) {
      this.setState({
        prevLeft: e.left,
        prevTop: e.top,
        toLeft: e.scrollLeft
      });
    } else {
      this.setState({
        prevLeft: e.left,
        prevTop: e.top
      });
    }
  };

  /**
   * switchTab
   * @param id
   */
  switchTab = (id) => {
    this.setState({ currentTab: id });
  };

  /**
   * updateTableWidth
   */
  updateTableWidth = () => {
    const elem = document.getElementById('explainabilityContent');
    if (elem) {
      const computedStyle =
        window?.getComputedStyle && window.getComputedStyle(elem, null);
      const newWidth = computedStyle?.getPropertyValue('width');
      this.setState({
        tableWidth: parseInt(newWidth)
      });
    }
  };

  /**
   * render
   * @returns {div}
   */
  render() {
    const { dimensions } = this.state;
    const {
      treeData,
      alertDetail,
      featureViewData,
      transactionTypeFilterData
    } = this.props;
    let alertScoreLoading = false;
    const featureData = [];
    if (Array.isArray(treeData) && treeData.length === 0) {
      alertScoreLoading = true;
    }
    if (Array.isArray(featureViewData) && featureViewData.length !== 0) {
      featureViewData.map((group) => {
        const { typology } = group;
        typology.map((redFlag) => {
          featureData.push(redFlag);
        });
      });
    }

    let sectionHeader = (
      <div className={classnames('row', style.primaryTableHead)}>
        <span className={style.assocTitle}>Alert Score Explainability</span>
        <div className={style.pullRight}>
          <div className={classnames(style.explainabilityToggle, 'clearfix')}>
            <div
              className={classnames(style.table_selection_list, style.ml_auto)}>
              <a
                style={{ marginRight: 10 }}
                id="featureView"
                onClick={() => this.switchTab(0)}
                className={classnames(
                  this.state.currentTab === 0 ? style.active : ''
                )}>
                Feature View
              </a>

              <a
                id="oneView"
                onClick={() => this.switchTab(1)}
                className={classnames(
                  this.state.currentTab === 1 ? style.active : ''
                )}>
                Tree View
              </a>
            </div>
          </div>
        </div>
      </div>
    );
    /**
     * renderedView for header
     */
    let renderedView = (
      <div className={classnames(style.card, 'mt-3')}>
        <div className={classnames(style.sectionHeader)}>{sectionHeader}</div>
        <div></div>
      </div>
    );
    /**
     * return content view for  explanability
     */
    return (
      <div id="explainabilityContent">
        <div>{renderedView}</div>

        <div
          className="tabs-content"
          style={treeContainerStyles}
          ref={(tc) => (this.treeContainer = tc)}>
          {
            //feature view
            this.state.currentTab === 1 &&
              Array.isArray(treeData) &&
              treeData.length > 0 && (
                <Tree
                  orientation="horizontal"
                  data={treeData}
                  translate={{
                    x: 600,
                    y: dimensions?.height ? dimensions.height / 2 : 0
                  }}
                  initialDepth={1}
                  zoomable={true}
                  scaleExtent={{ min: 1, max: 1 }}
                  nodeSize={{ x: 250, y: 140 }}
                  pathFunc="elbow"
                  allowForeignObjects
                  nodeLabelComponent={{
                    render: (
                      <NodeLabel
                        alertDetail={alertDetail}
                        className={style.myLabelComponentInSvg}
                      />
                    ),
                    foreignObjectWrapper: {
                      height: 140,
                      width: 150,
                      x: -30,
                      y: 10
                    }
                  }}
                />
              )
          }

          {
            //feature view
            this.state.currentTab === 0 && (
              <Table enableOverflowScroll={true}>
                <AlertFeatureViewHeader />
                {alertScoreLoading && (
                  <div
                    style={{
                      marginTop: 100,
                      position: 'absolute',
                      left: '50%'
                    }}>
                    <Wait4Me />
                  </div>
                )}
                {!alertScoreLoading && featureData.length === 0 && (
                  <div style={{ position: 'absolute', left: '50%' }}>
                    <NoDataToDisplay />
                  </div>
                )}
                <ExpandableRow
                  alertDetail={alertDetail}
                  transactionTypeFilterData={transactionTypeFilterData}
                  featureData={featureData}
                />
              </Table>
            )
          }
        </div>
      </div>
    );
  }
}

Explainability.propTypes = {};

export default Explainability;
